import React from "react";

const ProductIcon = () => (
  <svg className="redirection-icon" x="0px" y="0px" viewBox="0 0 26.002 14.055">
    <path
      id="path847"
      d="M242.663,215.817a3.571,3.571,0,0,1-1.054-.515c-.1-.076-2.524-2.47-5.384-5.32l-5.2-5.183L231,207.708c-.029,3.149-.019,3.046-.33,3.229a.734.734,0,0,1-.956-.249c-.1-.18-.1-7.731,0-7.924a.878.878,0,0,1,.221-.245c.152-.113.193-.114,3.847-.129,4.079-.016,3.97-.025,4.183.324a.689.689,0,0,1-.179.936c-.15.111-.217.115-2.949.141l-2.8.027,1.672,1.686,5.154,5.2c3.962,4,3.761,3.829,4.592,3.829.881,0,.528.306,5.879-5.092,2.987-3.014,4.764-4.767,4.88-4.816a.7.7,0,0,1,.878.364.871.871,0,0,1,.038.39c-.034.254.574-.379-6.023,6.275-3.5,3.534-3.687,3.71-4.076,3.9a4.673,4.673,0,0,1-.707.282,4.067,4.067,0,0,1-1.659-.022Z"
      transform="translate(-229.385 -202.139)"
      strokeWidth="0.5"
    />
  </svg>
);

export default ProductIcon;
